import { observable } from "mobx";
import Model from "~/models/Model";

class Immersive3dTourZipProject extends Model {
  /**
   * @property {string|null}
   */
  @observable id = null;

  /**
   * @property {string|null}
   */
  @observable name = null;

  /**
   * @property {string|null}
   */
  @observable type = null;

  /**
   * @property {Array}
   */
  @observable floors = [];
}

export default Immersive3dTourZipProject;
